

const Image = ({ attributes, clientId }) => {
    const { sliders, indicator, isLazyLoad } = attributes;

    return sliders.map((slider, index) => {
        const { img } = slider || {};


        return <button key={index} type="button" data-bs-target={`#bsbCarousel-${clientId} .carousel`} data-bs-slide-to={index} className={`${index === 0 ? 'active' : ''}`} aria-current="true" aria-label={index}>
            {indicator?.type === 'image' && img?.url ? <>{isLazyLoad ? <img loading="lazy" data-src={img?.url} className="d-block w-100 lazyload" alt={img?.alt || img?.title} /> : <img src={img?.url} className="d-block w-100 " alt={img?.alt || img?.title} />} </> : ''}
        </button>
    })
}
export default Image;